var map = {
	"./Ship_0001.png": 7563,
	"./Ship_0002.png": 9232,
	"./Ship_0003.png": 3705,
	"./Ship_0004.png": 3622,
	"./Ship_0005.png": 559,
	"./Ship_0006.png": 3700,
	"./Ship_0007.png": 7597,
	"./Ship_0008.png": 9818,
	"./Ship_0009.png": 7571,
	"./Ship_0010.png": 5373,
	"./Ship_0011.png": 4244,
	"./Ship_0012.png": 6703,
	"./Ship_0013.png": 1606,
	"./Ship_0014.png": 6585,
	"./Ship_0015.png": 4480,
	"./Ship_0016.png": 6235,
	"./Ship_0017.png": 2578,
	"./Ship_0018.png": 3445,
	"./Ship_0019.png": 9580,
	"./Ship_0020.png": 4168,
	"./Ship_0021.png": 1649,
	"./Ship_0022.png": 1066,
	"./Ship_0023.png": 6275,
	"./Ship_0024.png": 5052,
	"./Ship_0025.png": 7941,
	"./Ship_0026.png": 3934,
	"./Ship_0027.png": 3159,
	"./Ship_0028.png": 3248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1564;